module.exports = __webpack_public_path__ + "img/google-tag-manager.569a049b.svg";